import React from 'react'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { SaleBanner } from '@/molecules/SaleBanner'
import { SaleBannerNew } from '@/molecules/SaleBannerNew'
import { TicketsNavBanner } from '@/molecules/TicketsNavBanner'
import { Footer } from '@/organisms/Footer'
import { SiteNav } from '@/organisms/SiteNav'
import { TheatricalReleaseRegion } from '@/types/codegen-federation'
import { useScreenType, ScreenType } from '@/utils/ScreenUtils'
import { BaseLayout } from '../BaseLayout'

export interface DefaultLayoutProps {
  children: React.ReactNode
  isDarkMode?: boolean
  siteNavGradient?: boolean
  siteNavTransparent?: boolean
  regions?: TheatricalReleaseRegion[]
  showFooter?: boolean
  hideNavigation?: boolean
  hideSaleBanner?: boolean
  hideTicketsNavBanner?: boolean
  saleNameOverride?: string | null
}

export const DefaultLayout: React.FC<DefaultLayoutProps> = ({
  children,
  isDarkMode = true,
  siteNavGradient = false,
  siteNavTransparent = false,
  regions,
  showFooter = true,
  hideNavigation = false,
  hideSaleBanner = false,
  hideTicketsNavBanner = false,
  saleNameOverride,
}) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <DefaultLayoutContent
        regions={regions}
        siteNavGradient={siteNavGradient}
        siteNavTransparent={siteNavTransparent}
        hideNavigation={hideNavigation}
        hideSaleBanner={hideSaleBanner}
        hideTicketsNavBanner={hideTicketsNavBanner}
        showFooter={showFooter}
        saleNameOverride={saleNameOverride}
      >
        {children}
      </DefaultLayoutContent>
    </BaseLayout>
  )
}

const DefaultLayoutContent: React.FC<DefaultLayoutProps> = ({
  children,
  siteNavGradient = false,
  siteNavTransparent = false,
  regions,
  showFooter = true,
  hideNavigation = false,
  hideSaleBanner = false,
  hideTicketsNavBanner = false,
  saleNameOverride,
}) => {
  const screenType = useScreenType()
  const isDesktop = screenType === ScreenType.desktop
  const showSaleBanner = !hideSaleBanner

  return (
    <>
      <TicketsNavBanner hide={hideTicketsNavBanner} />
      {showSaleBanner && !isDesktop && <SaleBanner position="top" saleNameOverride={saleNameOverride} />}
      {showSaleBanner && isDesktop && <SaleBannerNew saleNameOverride={saleNameOverride} />}
      <SiteNav
        hideNavigation={hideNavigation}
        regions={regions}
        gradientBackground={siteNavGradient}
        transparentBackground={siteNavTransparent}
      />
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
      {showFooter && <Footer />}
    </>
  )
}
